import React, { useState } from 'react';

interface IChip
{
    text: string;
    className?: string;
    onClick: () => void;
}

const MyChip : React.FC<IChip> = (props) =>
{
    const [active, setActive] = useState<boolean>(true);

    function onClickHandler() {
      props.onClick();
      setActive((prevState) =>{ return !active})
    }

    return (
      <button onClick={onClickHandler} className={`mx-2 my-1 px-4 py-2 rounded-full font-semibold text-sm w-2/12 max-w-xs min-w-fit
      align-center cursor-pointer active:bg-gray-300 transition duration-300 ease ${active? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
        {props.text}
      </button>
  )
}

export default MyChip